import { getSdk } from 'src/sdk';
interface BackgroundRemoveInput {
    url: string;
    signal?: AbortSignal;
}

interface BackgroundRemoveSuccess {
    success: true;
    data: {
        output: {
            url: string;
        };
    };
}

interface BackgroundRemoveError {
    success: false;
    errorMessage: string;
}

type BackgroundRemoveResult = BackgroundRemoveSuccess | BackgroundRemoveError;

export interface BackgroundResponse {
    id: string;
    status: string;
    output: Output;
    input: Input;
}
export interface Output {
    info: Info;
    url: string;
    options?: null;
    cropBoundingBox: CropBoundingBox;
}
export interface Info {
    inputWidth: number;
    inputHeight: number;
    remarks: string;
    outputWidth: number;
    outputHeight: number;
    classificationType: string;
}
export interface CropBoundingBox {
    x: number;
    y: number;
    width: number;
    height: number;
}
export interface Input {
    url: string;
    classificationType: string;
}

export async function backgroundRemove({ url, signal }: BackgroundRemoveInput): Promise<BackgroundRemoveResult> {
    try {
        const response = await getSdk().ImageMind.backgroundRemove({
            input: {
                url,
                classificationType: 'photo',
            },
            signal,
        });

        const isTransparent = response.output.info?.remarks?.includes('Background not removed');
        return isTransparent
            ? {
                  success: false,
                  errorMessage: 'Input image has a Transparency, those type of images are not supported',
              }
            : {
                  success: true,
                  data: response,
              };
    } catch (error: unknown) {
        return {
            success: false,
            errorMessage: (error as Error).message,
        };
    }
}
